import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _gDriveProdConfigs, _gtmIds, _tld;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { BIBME, CHEGG, CHEGG_NET, CHEGG_SIHP, CITATION_MACHINE, CITE_THIS_FOR_ME, EASYBIB, OWL } from '../types';
var GDRIVE_ENDPOINT = 'https://www.googleapis.com/drive/v3/files/';
var GDRIVE_SCOPE = 'https://www.googleapis.com/auth/drive';
var gDriveStatic = {
  scope: GDRIVE_SCOPE,
  endpoint: GDRIVE_ENDPOINT
};
var gDrivePgConfigBase = _objectSpread({
  apiKey: 'AIzaSyAcaqzIJh-P3Yq05r7F1vTG3FQyja2WmvM',
  appId: 'wpt-dev-143512',
  oauthId: '793846844721-15dqeae7ggjofrkngihgjinva1pe9lc3.apps.googleusercontent.com'
}, gDriveStatic);
var gDriveProdConfigs = (_gDriveProdConfigs = {}, _defineProperty(_gDriveProdConfigs, EASYBIB, _objectSpread({
  apiKey: 'AIzaSyCyfnvQqKUobdSdEdUBBG6yyTNSlWM8xhU',
  appId: 'easybib-plus',
  oauthId: '738852342504-fitv6mcd55l3h7lh329t1n8ma7le1v3r.apps.googleusercontent.com'
}, gDriveStatic)), _defineProperty(_gDriveProdConfigs, BIBME, _objectSpread({
  apiKey: 'AIzaSyDS5OYMiLLzLUY3vs_zLWxIcErv94xvgMo',
  appId: 'wpt-production',
  oauthId: '782384817026-pgqo32m2p35vfqe753o5dhlfgnn0k1bk.apps.googleusercontent.com'
}, gDriveStatic)), _defineProperty(_gDriveProdConfigs, CITATION_MACHINE, _objectSpread({
  apiKey: 'AIzaSyDc6cmOA_K8VNidURtqv1WyEC1J8jim1P8',
  appId: 'citationmachine-plus',
  oauthId: '938250379325-ffgqkgds53un9ciqf78v8680bt08qv62.apps.googleusercontent.com'
}, gDriveStatic)), _defineProperty(_gDriveProdConfigs, CHEGG, _objectSpread({
  apiKey: 'AIzaSyAvusspDdZ05mMTQkk0XlHRQh5yA8v5n1U',
  appId: 'chegg-writing',
  oauthId: '165598702916-2fam7j1ob2klebpr8fr68a0mftd48gjo.apps.googleusercontent.com'
}, gDriveStatic)), _defineProperty(_gDriveProdConfigs, CHEGG_SIHP, _objectSpread({
  apiKey: 'AIzaSyAvusspDdZ05mMTQkk0XlHRQh5yA8v5n1U',
  appId: 'chegg-writing',
  oauthId: '165598702916-2fam7j1ob2klebpr8fr68a0mftd48gjo.apps.googleusercontent.com'
}, gDriveStatic)), _gDriveProdConfigs);
var gtmIds = (_gtmIds = {}, _defineProperty(_gtmIds, EASYBIB, 'GTM-MS6L4L'), _defineProperty(_gtmIds, BIBME, 'GTM-T425DXK'), _defineProperty(_gtmIds, CITATION_MACHINE, 'GTM-PR4ZBX'), _defineProperty(_gtmIds, OWL, 'GTM-PR4ZBX'), _defineProperty(_gtmIds, CHEGG, 'GTM-MWT3Q4H'), _defineProperty(_gtmIds, CHEGG_SIHP, 'GTM-MWT3Q4H'), _defineProperty(_gtmIds, CITE_THIS_FOR_ME, 'GTM-MWT3Q4H'), _gtmIds);
var tld = (_tld = {}, _defineProperty(_tld, EASYBIB, 'com'), _defineProperty(_tld, BIBME, 'org'), _defineProperty(_tld, CITATION_MACHINE, 'net'), _defineProperty(_tld, OWL, 'net'), _defineProperty(_tld, CHEGG, 'com'), _defineProperty(_tld, CHEGG_SIHP, 'com'), _defineProperty(_tld, CITE_THIS_FOR_ME, 'com'), _tld);
var cheggPgDomain = function cheggPgDomain(site, pg) {
  return pg && site === CHEGG ? CHEGG_NET : site;
};
var basePlaygroundEndpoints = function basePlaygroundEndpoints(site) {
  return {
    cfeUrl: "https://playground.".concat(cheggPgDomain(site, true), ".").concat(tld[site]),
    wssUrl: 'wss://wss.wtai.ezbib.com/test',
    publicProxyUrl: 'https://proxy.writing.test.cheggnet.com/api/v1',
    wtaiExpressUrl: 'https://test.wtai.ezbib.com/express/api/v1',
    bffUrl: 'https://bff.writing.test.cheggnet.com/graphql'
  };
};
var baseProdEndpoints = function baseProdEndpoints(site) {
  return {
    cfeUrl: "https://www.".concat(site, ".").concat(tld[site]),
    wssUrl: 'wss://wss.wtai.easybib.com/prod',
    publicProxyUrl: 'https://proxy.writing.chegg.com/api/v1',
    wtaiExpressUrl: 'https://wtai.easybib.com/express/api/v1',
    bffUrl: 'https://bff.writing.chegg.com/graphql'
  };
};
var baseConfig = function baseConfig(site, pg) {
  return {
    baseUrl: "".concat(cheggPgDomain(site, pg), ".").concat(tld[site]),
    cookieDomain: ".".concat(cheggPgDomain(site, pg), ".").concat(tld[site]),
    gtmID: gtmIds[site]
  };
};
var playgroundConfig = function playgroundConfig(site) {
  return _objectSpread(_objectSpread(_objectSpread({}, baseConfig(site, true)), basePlaygroundEndpoints(site)), {}, {
    gdrive: gDrivePgConfigBase
  });
};
var prodConfig = function prodConfig(site) {
  return _objectSpread(_objectSpread(_objectSpread({}, baseConfig(site)), baseProdEndpoints(site)), {}, {
    gdrive: gDriveProdConfigs[site]
  });
};
export var siteConfig = function siteConfig(site, pg) {
  return pg ? playgroundConfig(site) : prodConfig(site);
};